export enum BillingEventType {
  CandidateMatched = "CandidateMatched",
  CandidateTransferred = "CandidateTransferred",
  CandidateAged150Days = "CandidateAged150Days",
  UserAdded = "UserAdded",
  LicenseFee = "LicenseFee",
  Contingent = "Contingent",
  ChatAddonFee = "ChatAddonFee",
  TalentPoolWebsiteAddonFee = "TalentPoolWebsiteAddonFee",
  CommissionCredited = "CommissionCredited",
  CvParsingFee = "CvParsingFee",
  DocuSealSigningFeeSes = "DocuSealSigningFeeSes",
  DocuSealSigningFeeAes = "DocuSealSigningFeeAes",
  DocuSealSigningFeeQes = "DocuSealSigningFeeQes",
  DocuSealIdVerificationFee = "DocuSealIdVerificationFee",
  RecurringFee = "RecurringFee",
}

export enum BillingEventTriggerType {
  // status changes
  CandidateStatusSetToMatched = "CandidateStatusSetToMatched",
  CandidateStatusSetToTransferred = "CandidateStatusSetToTransferred",
  CandidateStatusSetToInRecognition = "CandidateStatusSetToInRecognition",
  CandidateStatusSetToLabourMigrationFinished = "CandidateStatusSetToLabourMigrationFinished",
  // data changes
  CandidateArrivalDateChanged = "CandidateArrivalDateChanged",
  CandidateVisumChanged = "CandidateVisumChanged",
  CandidateWorkingStartChanged = "CandidateWorkingStartChanged",
  CandidateEmploymentConfirmationChanged = "CandidateEmploymentConfirmationChanged",
  CandidateEmployerChanged = "CandidateEmployerChanged",
  CandidateEstimatedArrivalDateChanged = "CandidateEstimatedArrivalDateChanged",
  CandidateEstimatedWorkingStartChanged = "CandidateEstimatedWorkingStartChanged",
  // file uploads
  CandidatePreContractUploaded = "CandidatePreContractUploaded",
  CandidateWorkingContractUploaded = "CandidateWorkingContractUploaded",
  CandidateTrainingContractUploaded = "CandidateTrainingContractUploaded",
  CandidateDeclarationOfEmploymentUploaded = "CandidateDeclarationOfEmploymentUploaded",
  CandidateFirstContractExtensionAfterUploaded = "CandidateFirstContractExtensionAfterUploaded",
  CandidateFirstContractExtensionPreUploaded = "CandidateFirstContractExtensionPreUploaded",
  CandidateSecondContractExtensionAfterUploaded = "CandidateSecondContractExtensionAfterUploaded",
  CandidateSecondContractExtensionPreUploaded = "CandidateSecondContractExtensionPreUploaded",
  CandidateTrainingCommitmentUploaded = "CandidateTrainingCommitmentUploaded",
  CandidateAgreementSponsorshipUploaded = "CandidateAgreementSponsorshipUploaded",
  CandidateRecognitionSponsorshipEmployerUploaded = "CandidateRecognitionSponsorshipEmployerUploaded",
  CandidateRecognitionSponsorshipCandidateUploaded = "CandidateRecognitionSponsorshipCandidateUploaded",
  CandidateInternContractUploaded = "CandidateInternContractUploaded",
  CandidateVisaUploaded = "CandidateVisaUploaded",
  CandidateHealthMembershipCertificateUploaded = "CandidateHealthMembershipCertificateUploaded",
  // license
  LicenseFee = "LicenseFee",
  UserAccountFee = "UserAccountFee",
  // recurring fees
  RecurringFee = "RecurringFee",
  // contingent
  ContingentOrderedManually = "ContingentOrderedManually",
  ContingentOrderedAutomatically = "ContingentOrderedAutomatically",
  // time based
  CandidateAged150Days = "CandidateAged150Days",
  // manually
  CandidateMatchedTriggeredManually = "CandidateMatchedTriggeredManually",
  CandidateTransferredTriggeredManually = "CandidateTransferredTriggeredManually",
  // automatically
  CandidateBillingDeferredToNextMonth = "CandidateBillingDeferredToNextMonth",

  //Addons
  ChatAddonFee = "ChatAddonFee",
  CvParsingFee = "CvParsingFee",
  DocuSealSigningFeeSes = "DocuSealSigningFeeSes",
  DocuSealSigningFeeAes = "DocuSealSigningFeeAes",
  DocuSealSigningFeeQes = "DocuSealSigningFeeQes",
  DocuSealIdVerificationFee = "DocuSealIdVerificationFee",
  TalentPoolWebsiteAddonFee = "TalentPoolWebsiteAddonFee",

  // Commission
  CommissionCredited = "CommissionCredited",
}

const billingEventTriggerMap: Record<BillingEventTriggerType, BillingEventType[]> = {
  [BillingEventTriggerType.CandidateArrivalDateChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateVisumChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateWorkingStartChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateEmploymentConfirmationChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateEmployerChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateEstimatedArrivalDateChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateEstimatedWorkingStartChanged]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateDeclarationOfEmploymentUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidatePreContractUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateWorkingContractUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateTrainingContractUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateFirstContractExtensionAfterUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateFirstContractExtensionPreUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateSecondContractExtensionAfterUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateSecondContractExtensionPreUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateTrainingCommitmentUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateAgreementSponsorshipUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateRecognitionSponsorshipEmployerUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateRecognitionSponsorshipCandidateUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateInternContractUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateVisaUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateHealthMembershipCertificateUploaded]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateStatusSetToMatched]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateStatusSetToTransferred]: [
    BillingEventType.CandidateMatched,
    BillingEventType.CandidateTransferred,
  ],
  [BillingEventTriggerType.CandidateStatusSetToInRecognition]: [
    BillingEventType.CandidateMatched,
    BillingEventType.CandidateTransferred,
  ],
  [BillingEventTriggerType.CandidateStatusSetToLabourMigrationFinished]: [
    BillingEventType.CandidateMatched,
    BillingEventType.CandidateTransferred,
  ],
  [BillingEventTriggerType.LicenseFee]: [BillingEventType.LicenseFee],
  [BillingEventTriggerType.UserAccountFee]: [BillingEventType.UserAdded],
  [BillingEventTriggerType.RecurringFee]: [BillingEventType.RecurringFee],
  [BillingEventTriggerType.CandidateAged150Days]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateMatchedTriggeredManually]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.CandidateTransferredTriggeredManually]: [BillingEventType.CandidateTransferred],
  [BillingEventTriggerType.ContingentOrderedManually]: [BillingEventType.Contingent],
  [BillingEventTriggerType.ContingentOrderedAutomatically]: [BillingEventType.Contingent],
  [BillingEventTriggerType.CandidateBillingDeferredToNextMonth]: [BillingEventType.CandidateMatched],
  [BillingEventTriggerType.ChatAddonFee]: [BillingEventType.ChatAddonFee],
  [BillingEventTriggerType.CvParsingFee]: [BillingEventType.CvParsingFee],
  [BillingEventTriggerType.DocuSealSigningFeeSes]: [BillingEventType.DocuSealSigningFeeSes],
  [BillingEventTriggerType.DocuSealSigningFeeAes]: [BillingEventType.DocuSealSigningFeeAes],
  [BillingEventTriggerType.DocuSealSigningFeeQes]: [BillingEventType.DocuSealSigningFeeQes],
  [BillingEventTriggerType.DocuSealIdVerificationFee]: [BillingEventType.DocuSealIdVerificationFee],
  [BillingEventTriggerType.TalentPoolWebsiteAddonFee]: [BillingEventType.TalentPoolWebsiteAddonFee],
  [BillingEventTriggerType.CommissionCredited]: [BillingEventType.CommissionCredited],
};

export function mapTriggerEventToBillingEvents(triggerEvent: BillingEventTriggerType): BillingEventType[] {
  return billingEventTriggerMap[triggerEvent] ?? [];
}

export function isCandidateRelated(type: BillingEventTriggerType): boolean {
  return [
    BillingEventTriggerType.CandidateAgreementSponsorshipUploaded,
    BillingEventTriggerType.CandidateStatusSetToMatched,
    BillingEventTriggerType.CandidateStatusSetToTransferred,
    BillingEventTriggerType.CandidateStatusSetToInRecognition,
    BillingEventTriggerType.CandidateStatusSetToLabourMigrationFinished,
    BillingEventTriggerType.CandidateArrivalDateChanged,
    BillingEventTriggerType.CandidateVisumChanged,
    BillingEventTriggerType.CandidateWorkingStartChanged,
    BillingEventTriggerType.CandidateEmploymentConfirmationChanged,
    BillingEventTriggerType.CandidateEmployerChanged,
    BillingEventTriggerType.CandidateEstimatedArrivalDateChanged,
    BillingEventTriggerType.CandidateEstimatedWorkingStartChanged,
    BillingEventTriggerType.CandidatePreContractUploaded,
    BillingEventTriggerType.CandidateWorkingContractUploaded,
    BillingEventTriggerType.CandidateTrainingContractUploaded,
    BillingEventTriggerType.CandidateDeclarationOfEmploymentUploaded,
    BillingEventTriggerType.CandidateFirstContractExtensionAfterUploaded,
    BillingEventTriggerType.CandidateFirstContractExtensionPreUploaded,
    BillingEventTriggerType.CandidateSecondContractExtensionAfterUploaded,
    BillingEventTriggerType.CandidateSecondContractExtensionPreUploaded,
    BillingEventTriggerType.CandidateTrainingCommitmentUploaded,
    BillingEventTriggerType.CandidateAgreementSponsorshipUploaded,
    BillingEventTriggerType.CandidateRecognitionSponsorshipEmployerUploaded,
    BillingEventTriggerType.CandidateRecognitionSponsorshipCandidateUploaded,
    BillingEventTriggerType.CandidateInternContractUploaded,
    BillingEventTriggerType.CandidateVisaUploaded,
    BillingEventTriggerType.CandidateHealthMembershipCertificateUploaded,
  ].includes(type);
}

export function isLicenseRelated(type: BillingEventTriggerType): boolean {
  return [BillingEventTriggerType.LicenseFee].includes(type);
}

export function isUserBookingRelated(type: BillingEventTriggerType): boolean {
  return [BillingEventTriggerType.UserAccountFee].includes(type);
}

export function isAddonServiceRelated(type: BillingEventTriggerType): boolean {
  return [
    BillingEventTriggerType.ChatAddonFee,
    BillingEventTriggerType.TalentPoolWebsiteAddonFee,
    BillingEventTriggerType.CvParsingFee,
    BillingEventTriggerType.DocuSealSigningFeeSes,
    BillingEventTriggerType.DocuSealSigningFeeAes,
    BillingEventTriggerType.DocuSealSigningFeeQes,
    BillingEventTriggerType.DocuSealIdVerificationFee,
  ].includes(type);
}

export function isContingentRelated(type: BillingEventTriggerType): boolean {
  return [
    BillingEventTriggerType.ContingentOrderedManually,
    BillingEventTriggerType.ContingentOrderedAutomatically,
  ].includes(type);
}

export function isCommissionRelated(type: BillingEventTriggerType): boolean {
  return [BillingEventTriggerType.CommissionCredited].includes(type);
}
